import Core from "@/modules/core/service/Core";

const url = "/api/disposition/order/{0}/budget"

export default {
    download (orderId) {
        return Core.download.perform(url.replace("{0}", orderId));
    }
}